export default function useCustomInputs() {
	const checkIsGroupCheckbox = (key: string): boolean => {
		return key.split(';').length > 1;
	};

	const handleSplitGroupCheckbox = (key: string): string[] => {
		const values: string[] = [];
		const keys = key.split(';');
		for (const subKey of keys) {
			values.push(subKey);
		}
		return values;
	};

	const prepareValueForGroupCheckbox = (value: string): number[] => {
		//THIS WILL PARSE KEYS OF EACH ITEM FROM FORMAT THAT API SENDS AND RETURN AS ARRAY OF SEPARATED KEYS
		return value
			.replace(/[{}]/g, '')
			.split(',')
			.map(num => parseInt(num.trim(), 10));
	};

	const reconstructGroupCheckboxKey = (value: string): string => {
		//THIS WILL RECONSTRUCT KEY FROM KEY THAT FRONT-END USE TO MATCH KEY THAT API ORIGINALLY SEND
		const items: string[] = value.split(';');
		return `{${items.join(',')}}`;
	};

	return {
		handleSplitGroupCheckbox,
		checkIsGroupCheckbox,
		prepareValueForGroupCheckbox,
		reconstructGroupCheckboxKey,
	};
}
